import React from "react";
import styles from "./ProgressBar.module.css";

const ProgressBar = ({
  value,
  maxValue,
  color = "#00aaff",
  thickness = 10,
}) => {
  const percentage = (value / maxValue) * 100;

  return (
    <div className={styles.horizontalprogressbar} style={{ height: thickness }}>
      <div
        className={styles.progressbarfill}
        style={{
          width: `${percentage}%`,
          backgroundColor: color,
          height: "100%",
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
